export const Remedy = () => (
  <svg
    width='48'
    height='48'
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_d_4538_49199)'>
      <rect x='4' width='40' height='40' rx='8' fill='#58C1B3' />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.8958 19.0192L19.8662 14.8486L24.8365 10.6779C27.8705 8.13211 32.3938 8.52785 34.9396 11.5619C37.4855 14.5959 37.0897 19.1192 34.0557 21.665L29.0854 25.8356L24.1151 30.0062C21.0811 32.552 16.5578 32.1563 14.0119 29.1223C11.4661 26.0883 11.8618 21.565 14.8958 19.0192Z'
        stroke='white'
        stroke-width='1.6'
      />
      <path
        d='M21.5273 18.8867L25.446 23.5569'
        stroke='white'
        stroke-width='1.6'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_4538_49199'
        x='0'
        y='0'
        width='48'
        height='48'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4538_49199'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_4538_49199'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
